/**
 * The function returns an error message for a given entity name when an API fails to fetch data.
 */
export const generateApiFailErrorMessage = (entityName: string): string => {
  return `Something went wrong while fetching ${entityName} data!`;
};

/**
 * The function generates a success message to indicate that an entity has been saved successfully.
 */
export const generateSaveSuccessMessage = (entityName: string): string => {
  return `${entityName} saved successfully!`;
};

/**
 * The function generates an error message to indicate that an entity failed to get saved.
 */
export const generateSaveErrorMessage = (entityName: string): string => {
  return `Failed to save ${entityName} details. Please try again!`;
};

/**
 * The function generates a success message to indicate that an entity has been updated successfully.
 */
export const generateUpdateSuccessMessage = (entityName: string): string => {
  return `${entityName} updated successfully!`;
};

/**
 * The function generates an error message to indicate that an entity failed to get updated.
 */
export const generateUpdateErrorMessage = (entityName: string): string => {
  return `Failed to update ${entityName} details. Please try again!`;
};

/**
 * The function generates a success message to indicate that an entity has been deleted successfully.
 */
export const generateDeleteSuccessMessage = (entityName: string): string => {
  return `${entityName} deleted successfully!`;
};

/**
 * The function generates an error message to indicate that an entity failed to get deleted.
 */
export const generateDeleteErrorMessage = (entityName: string): string => {
  return `Failed to delete ${entityName}. Please try again!`;
};
